import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import vuetify from './plugins/vuetify'
import './registerServiceWorker'

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

const moment = require('moment')
require('moment/locale/pt-br')
require('moment-recur');
Vue.use(require('vue-moment'), {
    moment
})

Vue.use(VueToast, {
    position: 'bottom-right',
    duration: 5000,
})

import money from "v-money";
Vue.use(money, { precision: 2 });

Vue.component("date-range-picker", require("./components/DateRangePicker.vue").default);

Vue.config.productionTip = false

import VueExcelXlsx from 'vue-excel-xlsx';
Vue.use(VueExcelXlsx);

new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')